export const environment = {
  production: true,
  apiURL: 'https://admin.plataforma.producao.sesc.digital/admin',
  loginApi: 'https://authentication.plataforma.producao.sesc.digital',
  sitePublicURL: 'https://sesc.digital/',
  EMBED_PLAYER_URL: 'https://video-player-web.sesc.digital/',
  LAMBDA_APP: 'https://j9ekgdvh3k.execute-api.us-west-2.amazonaws.com/prod/',

  sambaUrl: 'https://api.spalla.io/v1/',
  sambaUploadUrl: 'https://upload.spalla.io/v1/',
  sambaToken:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3NDcwNjA5ODIsImlhdCI6MTc0NzA2MDk4MiwianRpIjoiMDE5NmM0ZjMtMDQxMy03ZTE5LThiYjAtNWYzNGU4OGRiMzI5IiwiaXNzIjoiU3BhbGxhIn0.ICd_syidIx-K8tH0D7r3vDp1prolWWCle34MtJJjG6c',
  directoryId: '2r7sirKn24QmeBZtLz9wQzCeBIm',
  directoryDRMId: '2r7sibApUz21X3J8z81ADA03Qsn',

  aws: {
    apikey: 'GZFN0rEtsz8tbekGjoGPL5mLJqiqTrm1tXnhHhPi',
    generateSignedUrl: 'https://paf4dh2h82.execute-api.us-west-2.amazonaws.com/prod/admin/presigned-upload',
    completeUploadUrl: 'https://paf4dh2h82.execute-api.us-west-2.amazonaws.com/prod/admin/multipart-upload-complete',
    reprocessMedia: 'https://paf4dh2h82.execute-api.us-west-2.amazonaws.com/prod/admin/job-resubmit'
  }
};
